module.exports = __webpack_public_path__ + "media/images/builders-209ccc06bf1779aca546ac62c24ebb1f.jpg";